import { render, staticRenderFns } from "./ReporteComparativoConfiguracion.vue?vue&type=template&id=31a87324&scoped=true"
import script from "./ReporteComparativoConfiguracion.vue?vue&type=script&lang=js"
export * from "./ReporteComparativoConfiguracion.vue?vue&type=script&lang=js"
import style0 from "./ReporteComparativoConfiguracion.vue?vue&type=style&index=0&id=31a87324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a87324",
  null
  
)

export default component.exports